/**
 * Русские строки веб-админки. Канонический источник: набор ключей этого файла
 * задаёт тип `TKey`, поэтому `uz.ts` обязан содержать те же ключи — иначе
 * TypeScript не соберётся.
 *
 * Подстановки — в фигурных скобках: `{count}`, `{title}`.
 */
export const ru = {
  // -- Общее --------------------------------------------------------------
  'app.name': 'LMS Admin',
  'common.cancel': 'Отмена',
  'common.confirm': 'Подтвердить',
  'common.save': 'Сохранить',
  'common.create': 'Создать',
  'common.edit': 'Редактировать',
  'common.delete': 'Удалить',
  'common.search': 'Поиск',
  'common.add': 'Добавить',
  'common.all': 'Все',
  'common.actions': 'Действия',
  'common.action': 'Действие',
  'common.status': 'Статус',
  'common.title': 'Название',
  'common.role': 'Роль',
  'common.noData': 'Нет данных',
  'common.enable': 'Включить',
  'common.disable': 'Выключить',
  'common.active': 'активен',
  'common.archived': 'архив',
  'common.toArchive': 'В архив',
  'common.unarchive': 'Вернуть',
  'common.time': 'Время',
  'common.reason': 'Причина',
  'common.days': 'Дней',
  'common.currency': 'сум',
  'common.dayShort': 'дн.',
  'common.hourShort': 'ч',

  // -- Навигация и заголовки ----------------------------------------------
  'nav.dashboard': 'Дашборд',
  'nav.channels': 'Каналы',
  'nav.courses': 'Курсы',
  'nav.calendar': 'Календарь',
  'nav.payments': 'Платежи',
  'nav.users': 'Ученики',
  'nav.kicks': 'Кики',
  'nav.paymentMethods': 'Реквизиты',
  'nav.settings': 'Настройки',
  'page.calendar': 'Календарь публикаций',
  'page.kicks': 'Журнал киков',
  'header.logout': 'Выйти',
  'lang.switchLabel': 'Язык интерфейса',
  'lang.uz': "O'zbekcha",
  'lang.ru': 'Русский',
  'access.denied': 'Недостаточно прав для просмотра этого раздела.',
  'toast.close': 'Закрыть',

  // -- Логин --------------------------------------------------------------
  'login.subtitle': 'Войдите через Telegram-аккаунт администратора',
  'login.botUsernameMissing': 'VITE_TELEGRAM_BOT_USERNAME не задан в frontend/.env.local.',
  'login.checking': 'Проверка...',
  'login.failed': 'Не удалось войти.',
  'login.devDivider': 'или для разработки',
  'login.password': 'Пароль',
  'login.byPassword': 'Войти по паролю',
  'login.hideDev': 'Скрыть dev-вход',
  'login.adminsOnly': 'Доступ только для администраторов',

  // -- Дашборд ------------------------------------------------------------
  'dashboard.activeStudents': 'Активные ученики',
  'dashboard.revenue': 'Доход (30 дн.)',
  'dashboard.signups': 'Регистрации (30 дн.)',
  'dashboard.expiring7d': 'Истекает за 7 дн.',
  'dashboard.pendingPayments': 'На модерации',
  'dashboard.revenueByDay': 'Доход по дням',
  'dashboard.signupsByDay': 'Регистрации по дням',
  'dashboard.revenueLabel': 'Доход',
  'dashboard.signupsLabel': 'Регистрации',

  // -- Каналы -------------------------------------------------------------
  'channels.registerTitle': 'Регистрация канала',
  'channels.registerIntro': 'Канал регистрируется через бота. Сценарий:',
  'channels.step1': 'Создайте приватный Telegram-канал.',
  'channels.step2': 'Добавьте бота админом со всеми правами.',
  'channels.step3': 'В личке с ботом выполните /register_channel.',
  'channels.step4': 'Перешлите боту любое сообщение из канала.',
  'channels.step5': 'Канал появится в списке ниже.',
  'channels.emptyTitle': 'Каналов нет',
  'channels.emptyDescription': 'Зарегистрируйте первый канал через бота.',
  'channels.registeredAt': 'Зарегистрирован',

  // -- Курсы --------------------------------------------------------------
  'courses.heading': 'Курсы',
  'courses.new': 'Новый курс',
  'courses.emptyTitle': 'Курсов нет',
  'courses.emptyDescription': 'Создайте первый курс.',
  'courses.channel': 'Канал',
  'courses.method': 'Метод',
  'courses.grace': 'Грейс',
  'courses.reminders': 'Напоминания',
  'courses.dialogEdit': 'Курс: {title}',
  'courses.formChannel': 'Канал',
  'courses.formChannelLocked': 'привязка не меняется',
  'courses.formChannelPick': '— выберите —',
  'courses.formTitle': 'Название',
  'courses.formDescription': 'Описание',
  'courses.formPrice': 'Цена (сум)',
  'courses.formDuration': 'Длительность (дней)',
  'courses.formAccessMethod': 'Метод доступа',
  'courses.formGrace': 'Грейс (часов)',
  'courses.formRules': 'Правила курса',
  'courses.created': 'Курс создан',
  'courses.updated': 'Курс обновлён',
  'courses.saveFailed': 'Не удалось сохранить',
  'courses.toggleFailed': 'Не удалось изменить статус',

  // -- Календарь публикаций ------------------------------------------------
  'calendar.monthCaption': 'Календарь публикаций на {month}.',
  'calendar.addMaterial': 'Добавить материал',
  'calendar.emptyTitle': 'Материалов в этом месяце нет',
  'calendar.emptyNoCourses': 'Сначала создайте курс на странице «Курсы».',
  'calendar.emptyHint': 'Нажмите «Добавить материал», чтобы запланировать публикацию.',
  'calendar.untitled': '(без названия)',
  'calendar.reschedule': 'Перенести',
  'calendar.cancelPublish': 'Отменить',
  'calendar.confirmCancel': 'Отменить публикацию материала?',
  'calendar.materialDeleted': 'Материал удалён',
  'calendar.deleteFailed': 'Не удалось удалить',
  'calendar.rescheduled': 'Дата публикации обновлена',
  'calendar.rescheduleFailed': 'Не удалось перенести',
  'calendar.rescheduleTitle': 'Перенести материал',
  'calendar.rescheduleDescription': 'Новая дата и время публикации',
  'calendar.statusCancelled': 'отменён',
  'calendar.statusPublished': 'опубликован',
  'calendar.statusError': 'ошибка',
  'calendar.statusPending': 'ожидает',
  'calendar.newMaterial': 'Новый материал',
  'material.typeVideo': 'Видео',
  'material.typeDocument': 'Документ',
  'material.typePhoto': 'Фото',
  'material.typeAudio': 'Аудио',
  'material.typeVoice': 'Голосовое',
  'material.typeText': 'Текст',
  'material.course': 'Курс',
  'material.courseArchived': '(архив)',
  'material.type': 'Тип',
  'material.titleForAdmin': 'Название (для админки)',
  'material.titlePlaceholder': 'Урок 1: Введение',
  'material.file': 'Файл',
  'material.uploadedToTelegram': 'загружен в Telegram',
  'material.changeFile': 'Сменить',
  'material.usingExistingFileId': 'Используется готовый file_id ({prefix}…)',
  'material.uploading': 'Загрузка в Telegram…',
  'material.uploadingProgress': 'Загрузка на сервер… {percent}%',
  'material.pickFile': 'Нажмите, чтобы выбрать файл',
  'material.fileHint': 'видео / документ / фото / аудио · до {limit}',
  'material.tooLarge': 'Файл слишком большой ({size}). Лимит — {limit}.',
  'material.uploadFailed': 'Не удалось загрузить файл',
  'material.uploadFailedWith': 'Не удалось загрузить файл: {message}',
  'material.manualFileId': 'Использовать готовый file_id (продвинутое)',
  'material.fileUniqueIdOptional': 'file_unique_id (опционально)',
  'material.caption': 'Подпись (caption)',
  'material.captionPlaceholder': 'Описание под медиа',
  'material.textBody': 'Текст сообщения',
  'material.textBodyPlaceholder': 'Текст, который будет опубликован в канале',
  'material.scheduledAt': 'Дата и время публикации',
  'material.tzHint': 'Время в часовом поясе вашего устройства. Публикация — в указанный момент по серверу.',
  'material.pin': 'Закрепить в канале',
  'material.silent': 'Без уведомления',
  'material.scheduled': 'Материал запланирован',
  'material.createFailed': 'Не удалось создать',

  // -- Платежи ------------------------------------------------------------
  'payments.statusPending': 'Ждёт',
  'payments.statusApproved': 'Одобрен',
  'payments.statusRejected': 'Отклонён',
  'payments.statusCancelled': 'Отменён',
  'payments.emptyTitle': 'Платежей нет',
  'payments.emptyDescription': 'В этом статусе пока пусто.',
  'payments.student': 'Ученик',
  'payments.course': 'Курс',
  'payments.amount': 'Сумма',
  'payments.receivedAt': 'Получен',
  'payments.approve': 'Одобрить',
  'payments.reject': 'Отклонить',
  'payments.issueAccess': 'Выдать доступ',
  'payments.issueAccessHint': 'Создать invite-ссылку и отправить ученику',
  'payments.accessGranted': 'Доступ выдан',
  'payments.accessGrantedAt': 'Доступ выдан {when}',
  'payments.approved': 'Платёж одобрен, ссылка отправлена ученику',
  'payments.approveFailed': 'Не удалось одобрить',
  'payments.rejected': 'Платёж отклонён, ученик уведомлён',
  'payments.rejectFailed': 'Не удалось отклонить',
  'payments.inviteSent': 'Ссылка-приглашение отправлена ученику',
  'payments.issueFailed': 'Не удалось выдать доступ: {message}',
  'payments.alreadyGranted': 'Доступ уже выдан {when}.',
  'payments.reissueConfirm': 'Всё равно перевыпустить ссылку?',
  'payments.receiptTitle': 'Чек #{id}',
  'payments.receiptLoadFailed': 'Не удалось загрузить чек: {error}',
  'payments.receiptComment': 'Комментарий: {caption}',
  'payments.rejectTitle': 'Отклонить платёж #{id}',
  'payments.rejectDescription': 'Причина будет отправлена ученику в Telegram.',
  'payments.rejectPlaceholder': 'Например: чек неразборчив, не та сумма...',

  // -- Ученики ------------------------------------------------------------
  'users.searchPlaceholder': 'Имя, @username, телефон, ID...',
  'users.allStatuses': 'Все статусы',
  'users.emptyTitle': 'Учеников нет',
  'users.emptyDescription': 'По выбранным фильтрам никого не найдено.',
  'users.fullName': 'ФИО',
  'users.region': 'Регион',
  'users.registeredAt': 'Регистрация',
  'users.totalShown': 'Всего: {total}. Показано: {shown}.',

  // -- Карточка ученика ----------------------------------------------------
  'userCard.notFound': 'Пользователь не найден.',
  'userCard.backToList': 'К списку',
  'userCard.block': 'Заблокировать',
  'userCard.unblock': 'Разблокировать',
  'userCard.age': 'Возраст',
  'userCard.phone': 'Телефон',
  'userCard.rulesAcceptedAt': 'Правила приняты',
  'userCard.subscriptions': 'Подписки ({count})',
  'userCard.noSubscriptions': 'Нет подписок.',
  'userCard.subActive': 'активна',
  'userCard.subFinished': 'завершена',
  'userCard.cancelReason': 'Причина отмены: {reason}',
  'userCard.extend': 'Продлить',
  'userCard.paymentHistory': 'История платежей ({count})',
  'userCard.noPayments': 'Платежей нет.',
  'userCard.extendTitle': 'Продлить подписку «{title}»',
  'userCard.extendDescription': 'Подписка будет продлена на указанное число дней.',
  'userCard.blockTitle': 'Заблокировать ученика',
  'userCard.blockDescription':
    'Пользователь будет удалён из всех каналов и не сможет оплачивать новые курсы.',
  'userCard.blockReason': 'Причина (обязательно)',

  // -- Кики ---------------------------------------------------------------
  'kicks.emptyTitle': 'Кикбэков не было',
  'kicks.student': 'Ученик',
  'kicks.channel': 'Канал',
  'kicks.restored': 'восстановлен',
  'kicks.kicked': 'кикнут',
  'kicks.restore': 'Восстановить',
  'kicks.restoreTitle': 'Восстановить доступ',
  'kicks.restoreDescription':
    'Подписка будет реактивирована и продлена на указанное число дней. Пользователь получит ссылку для возврата в канал.',
  'kicks.extendDays': 'Дней продления',

  // -- Реквизиты ----------------------------------------------------------
  'methods.title': 'Реквизиты для приёма оплаты',
  'methods.description':
    'Эти данные показываются ученикам при оплате. Отключённые методы не видны в боте.',
  'methods.emptyTitle': 'Реквизиты не настроены',
  'methods.emptyDescription':
    'Добавьте первый способ оплаты — без него бот не сможет принимать чеки.',
  'methods.card': 'Карта',
  'methods.holder': 'Держатель',
  'methods.bank': 'Банк',
  'methods.statusOn': 'активна',
  'methods.statusOff': 'выключена',
  'methods.confirmDelete': 'Удалить «{title}»?',
  'methods.deleted': 'Реквизиты удалены',
  'methods.deleteFailed': 'Не удалось удалить',
  'methods.created': 'Реквизиты созданы',
  'methods.updated': 'Реквизиты обновлены',
  'methods.toggleFailed': 'Не удалось изменить статус',
  'methods.saveFailed': 'Не удалось сохранить',
  'methods.newTitle': 'Новый способ оплаты',
  'methods.editTitle': 'Редактировать: {title}',
  'methods.formTitle': 'Название *',
  'methods.formTitlePlaceholder': 'Например: «Перевод на Humo»',
  'methods.formCard': 'Номер карты',
  'methods.formCardError': 'Номер должен содержать 13–19 цифр',
  'methods.formHolder': 'Держатель',
  'methods.formBank': 'Банк',
  'methods.formBankPlaceholder': 'Капитал Банк',
  'methods.formSortOrder': 'Порядок отображения',
  'methods.formInstructions': 'Инструкция для ученика (опционально)',
  'methods.formInstructionsPlaceholder':
    'Например: «В назначении укажите ваш Telegram username»',
  'methods.formActive': 'Активен (показывать ученикам в боте)',

  // -- Настройки ----------------------------------------------------------
  'settings.promoteTitle': 'Назначить администратора',
  'settings.promoteDescription':
    'Только super_admin может назначать другим пользователям admin-роли.',
  'settings.telegramId': 'Telegram ID',
  'settings.roleModerator': 'moderator — только модерация платежей',
  'settings.roleAdmin': 'admin — управление курсами и учениками',
  'settings.roleSuperAdmin': 'super_admin — полный доступ',
  'settings.promote': 'Назначить',
  'settings.demoteTitle': 'Снять админ-роль',
  'settings.demote': 'Снять роль',
  'settings.done': 'Готово.',
} as const;

export type TKey = keyof typeof ru;
